export default __webpack_public_path__ + "static/media/item-placeholder.0a963919.svg";